import {Injectable} from '@angular/core';
import {of, Observable, throwError, BehaviorSubject} from 'rxjs';
import {map} from 'rxjs/operators';
import {ApiService} from './api.service';
import {WindowRefService} from '../window-ref.service';
import {User} from '../../core/models/user.model';

export class ILoginContext {
    username: string;
    password: string;
    token: string;
}

const defaultUser = {
    username: 'Mathis',
    password: '12345',
    token: '12345'
};
const routes = {
    loginCheck: '/check',
};

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    token: string;
    private currentUserSubject: BehaviorSubject<User>;

    constructor(private apiService: ApiService, private winRef: WindowRefService) {
        this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
    }

    login(loginContext: ILoginContext): Observable<any> {
        let params = {_email: loginContext.username, _password: loginContext.password,idetab:this.winRef.appConfigSite.idEtab};
        return this.apiService.post("/".concat(this.winRef.appConfigSite.defaultlangue,routes.loginCheck), params)
            .pipe(map((response: any) => {
                if (response && response.success && response.user != undefined) {
                    let user: User = new User();
                    user.username =  response.user.username;
                    user.password = 'XXXXX',
                    user.token = Math.random().toString(36).substring(2) //token random
                    localStorage.setItem('currentUser', JSON.stringify(user));
                    this.currentUserSubject.next(user);
                    return user;
                }
//                return throwError('Invalid username or password');
            }));
    }

    logout(): Observable<boolean> {
        // remove user from local storage to log user out
        localStorage.removeItem('currentUser');
        this.currentUserSubject.next(null);
        return of(false);
    }
    
    public get currentUserValue(): User {
        return this.currentUserSubject.value;
    }

    getToken() {
        return this.getToken;
    }

}
